module.exports = __webpack_public_path__ + "c4d36f0e36b306c9d4546d18c52b324e.svg";